export default __webpack_public_path__ + "static/media/logo_westbahn.e7fb7565.svg";